// extracted by mini-css-extract-plugin
module.exports = {"officePage":"OfficePage_officePage__3ob8E","pageContent":"OfficePage_pageContent__hlO_F","content":"OfficePage_content__rpQPQ"};